import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import clsx from 'clsx'
import { Loading, Player, YouTubePlayer } from 'src/components'
import { MediaProps, MediaLightboxType, MediaLightboxProvider, PathParams } from './media.types'
import { IframeWrapper, LoaderWrapper } from './media.styles'

const Media = ({ provider, src, title, type, className }: MediaProps) => {
  const { lang } = useParams<PathParams>()
  const [loading, setLoading] = useState(type === MediaLightboxType.IMAGE)

  const isImage = type === MediaLightboxType.IMAGE
  const isIframe = type === MediaLightboxType.IFRAME
  const isYouTubePlayer = isIframe && provider === MediaLightboxProvider.YOUTUBE
  const isHotmartPlayer = isIframe && provider === MediaLightboxProvider.HOTMART

  const handleImageLoad = () => {
    setTimeout(() => {
      setLoading(false)
    }, 500)
  }

  useEffect(() => {
    setLoading(type === MediaLightboxType.IMAGE)
  }, [src])

  if (isImage) {
    return (
      <>
        {loading && (
          <LoaderWrapper className="_d-flex _align-items-center _justify-content-center">
            <Loading />
          </LoaderWrapper>
        )}

        <img
          className={clsx(className, {
            '_d-none': loading,
            '_d-block': !loading
          })}
          src={src}
          alt={title}
          onLoad={handleImageLoad}
        />
      </>
    )
  }

  if (isYouTubePlayer) {
    return (
      <IframeWrapper>
        <YouTubePlayer
          className={className}
          id={src}
          autoplay={1}
          rel={0}
          showinfo={0}
          hl={lang}
          allowFullScreen
        />
      </IframeWrapper>
    )
  }

  if (isHotmartPlayer) {
    return (
      <IframeWrapper>
        <Player
          id={Number(src)}
          className={className}
          playerConfig={{
            autoplay: true,
            watchBeginning: false
          }}
        />
      </IframeWrapper>
    )
  }

  return null
}

export default Media
